import React from "react";

import { faInfoCircle } from "@performyard/fontawesome/pro-regular-svg-icons";

import { Icon } from "../../../atoms/Icon";
import { Text } from "../../../atoms/Text";
import { useInputField } from "../InputContext";

/**
 * An error message that is displayed below the input
 */
export const InputError = () => {
	const { error, id } = useInputField();

	return (
		<div className="flex items-start gap-1" role="alert" aria-live="assertive">
			<Icon icon={faInfoCircle} size={16} color="red-5" aria-hidden="true" />
			<Text size="paragraph-3" color="red-5" weight="regular" aria-live="polite" id={`error-${id}`}>
				{error || ""}
			</Text>
		</div>
	);
};
